// extracted by mini-css-extract-plugin
export var container = "_mf-0";
export var dotAnimation = "_mf-2";
export var dotsLoading = "_mf-1";